/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";
import { ui } from "./ui/index";
import { user } from "@/store/user";
import { poll } from "@/store/poll";
import { IState } from "@/interfaces/IState";
import { toast } from "@/store/toast";
import { lesson } from "@/store/lesson";
import { modal } from "@/store/modal";
import { user } from "@/store/user";
import { task } from "./task/index";
import { activity } from "@/store/activity";
import { resource } from "@/store/resource";
import { pagination } from "@/store/pagination";
import createPersistedState from 'vuex-persistedstate';
import { pdf } from "./pdf";

Vue.use(Vuex);

export default new Vuex.Store<IState>({
    modules: {
        ui,
        toast: toast,
        lesson,
        task,
        modal,
        user,
        activity,
        resource,
        pagination,
        poll,
        pdf
    },
    plugins: [createPersistedState()]
});
